import React, { useEffect, useState } from "react";
import AllHeader from "../../../components/Navbar/AllHeader";
import Filter from "../destination/components/Filter";
import Footer from "../../../components/footerPage/Footer";
import BodyContact from "./components/BodyContact";
import SEO from "../../../components/SEO/SEO";

function Contact() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <SEO
        title={
          selectedLanguage === "en"
            ? "Contact Us | Take My Yacht"
            : "ติดต่อเรา | Take My Yacht"
        }
        description={
          selectedLanguage === "en"
            ? "Get in touch with Take My Yacht for luxury yacht charters with professional crew. We operate across Thailand, offering exceptional yachting experiences."
            : "ติดต่อ Take My Yacht สำหรับบริการเช่าเรือยอชต์สุดหรู พร้อมลูกเรือมืออาชีพ ให้บริการทั่วประเทศไทย พร้อมประสบการณ์การล่องเรือที่น่าประทับใจ"
        }
        url="https://takemyyacht.com/contact"
        schema={{
          "@context": "https://schema.org",
          "@type": "ContactPage",
          name:
            selectedLanguage === "en"
              ? "Contact Take My Yacht"
              : "ติดต่อ Take My Yacht",
          description:
            selectedLanguage === "en"
              ? "Contact page for Take My Yacht yacht charter services in Thailand"
              : "หน้าติดต่อสำหรับบริการเช่าเรือยอชต์ของ Take My Yacht ในประเทศไทย",
          publisher: {
            "@type": "Organization",
            name: "Take My Yacht",
            url: "https://takemyyacht.com",
          },
        }}
      />

      <div>
        <AllHeader />
        <BodyContact />
        <Footer />
      </div>
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          aria-label="Scroll to top"
          style={{
            position: "fixed",
            bottom: "24px",
            right: "24px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            border: "none",
            backgroundColor: "#3291B6", // สีเดิม
            color: "#fff",
            cursor: "pointer",
            boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.25s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          {/* Chevron Up */}
          <svg
            width="26"
            height="26"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </button>
      )}
    </>
  );
}

export default Contact;
